export function isProdEnvironment(environment) {
    return environment === 'prod' || environment === 'demo';
}
